<img [src]="'./assets/images/login_with_fb_'+lang+'.png'" class="facebook-login-button" (click)="FBLogin()">